import { createContext, useContext } from 'react';

import type { ClearScope } from '../features/schedule/ClearScheduleDialog';
import type { WeekStats } from '../features/schedule/weekStats';

/**
 * The week, as the account page needs it.
 *
 * App holds the user's lists, the directory that turns their ids into events
 * and the attendance trims a conflict depends on. The account page is drawn
 * *over* App and stays mounted with it (AppShell), so rather than a second
 * copy of all three it is handed the four numbers and the one destructive
 * action it needs. Null on a page App does not draw under — a shared schedule,
 * the sign-up questions — where there is no week to report.
 */
export interface WeekSummary {
  stats: WeekStats;
  /** What each scope of "Clear my Schedule" would take. */
  counts: { all: number; scheduled: number };
  clear: (scope: ClearScope) => void;
}

export const WeekContext = createContext<WeekSummary | null>(null);

export const useWeek = (): WeekSummary | null => useContext(WeekContext);
